import { Alert, Box } from "@mui/material";
import { theme } from "app/App";
import Fieldset from "components/form/Fieldset";

export function ApontamentoParamItem({ label, children }) {
    return (
        // TODO: mover cores para o tema
        <Box
            sx={{
                display: "flex",
                gap: 1,
                p: 1,
                backgroundColor: theme.palette.grey[200],
                fontSize: "0.9em",
                flexWrap: "wrap",
            }}
        >
            <strong>{label}</strong>
            <span>{children}</span>
        </Box>
    );
}

export default function ApontamentoClienteParams({
    params,
    noParams = "Parâmetros do cliente não configurados para este indicador.",
    children,
}) {
    return (
        <Fieldset label="Parâmetros do Cliente" fullWidth>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {params ? children : <Alert severity="info">{noParams}</Alert>}
            </Box>
        </Fieldset>
    );
}
